import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { useSelector } from 'react-redux';

import { trackOffersReliableLabelClick, TReliableLabel } from './tracking';
import { ReliableBlockRedesigned } from '../../components/ReliableBlockRedesigned';
import { reliabilitySelector } from '../../selectors/reliability';

export function ReliableBlockContainer() {
  const reliability = useSelector(reliabilitySelector);

  const onReliableLabelClick = (label: TReliableLabel) => (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#reliable',
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackOffersReliableLabelClick(label);
  };

  return (
    <ReliableBlockRedesigned
      reliability={reliability}
      onReliableClick={onReliableLabelClick('flats_reliable_dev')}
      onProblemClick={onReliableLabelClick('flats_problem_building')}
    />
  );
}
